import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { EmailType } from 'src/app/shared/common';

import { Constants } from '../../common';
import { LoginForm } from '../../interface';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationApi {
  constructor(private baseAPI: BaseAPI) {}
  // login api
  login(loginData: LoginForm): Observable<string> {
    return this.baseAPI
      .post(Constants.LOGIN_API_URL, loginData)
      .pipe(map((res) => res.accessToken));
  }
  // forget password api
  forgetPassword(email: EmailType): Observable<string> {
    return this.baseAPI
      .post(Constants.FORGET_PASSWORD_API_URL, email)
      .pipe(map((res) => res['message']));
  }

  // logout --> not have backend end point

  logout(): Observable<boolean> {
    return of(true).pipe(delay(10));
  }
}
